<template>
  <div class="client-manage">
    <div class="breadcrumb">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>接入</el-breadcrumb-item>
        <el-breadcrumb-item>客户端</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="page-header">
      <div class="client-title">客户端管理</div>
      <div class="client-desc">
        一站式管理和配置应用接入渠道，实时监测在线状态，设置智能体在
        渠道端的触发、回复等策略，配置群聊和智能体的绑定关系。前往文档中心
      </div>
      <el-button type="primary" class="upgrade-btn">前往升级</el-button>
    </div>

    <div class="feature-section">
      <el-row :gutter="20">
        <el-col :span="8">
          <div class="feature-card">
            <div class="feature-icon conversation-icon">
              <i class="el-icon-chat-line-round"></i>
            </div>
            <div class="feature-content">
              <div class="feature-title">对话策略配置</div>
              <div class="feature-desc">选择应用/工作流，一键开启自建渠道，托管接入渠道私聊、群聊的智能能力</div>
              <div class="feature-tags">
                <el-tag size="small" type="success">标准版 <i class="el-icon-check"></i></el-tag>
              </div>
            </div>
          </div>
        </el-col>

        <el-col :span="8">
          <div class="feature-card">
            <div class="feature-icon monitor-icon">
              <i class="el-icon-data-line"></i>
            </div>
            <div class="feature-content">
              <div class="feature-title">离线监控通知</div>
              <div class="feature-desc">实时监控接入渠道的智能体运行状态，离线及时发送短信，公众号消息通知保障 AI 服务稳定运行</div>
              <div class="feature-tags">
                <el-tag size="small" type="success">标准版 <i class="el-icon-check"></i></el-tag>
              </div>
            </div>
          </div>
        </el-col>

        <el-col :span="8">
          <div class="feature-card">
            <div class="feature-icon web-icon">
              <i class="el-icon-connection"></i>
            </div>
            <div class="feature-content">
              <div class="feature-title">网页嵌入配置 <i class="el-icon-arrow-right"></i></div>
              <div class="feature-desc">设置个性化的网页嵌入对话窗样式，配置 Web 站点中无需展示对话框的页面，开启浮窗、语音输入及转人工能力</div>
              <div class="feature-tags">
                <el-tag size="small" type="success">标准版 <i class="el-icon-check"></i></el-tag>
              </div>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>

    <div class="client-list">
      <div class="list-header">
        <div class="list-title">客户端列表</div>
        <div class="list-actions">
          <el-input placeholder="搜索客户端" prefix-icon="el-icon-search" v-model="searchText" size="small"
            style="width: 200px; margin-right: 10px;"></el-input>
          <el-button type="primary" size="small" icon="el-icon-plus">添加客户端</el-button>
        </div>
      </div>

      <el-table :data="filteredClients" style="width: 100%" empty-text="暂无客户端数据">
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column label="客户端名称" min-width="200">
          <template slot-scope="scope">
            <div class="client-info">
              <div class="client-icon" :class="scope.row.type | typeClass">
                <i :class="scope.row.type | typeIcon"></i>
              </div>
              <div>
                <div class="client-name">{{ scope.row.name }}</div>
                <div class="client-id">ID: {{ scope.row.id }}</div>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="status" label="状态" width="100">
          <template slot-scope="scope">
            <el-tag
              :type="scope.row.status === 'online' ? 'success' : (scope.row.status === 'offline' ? 'danger' : 'info')"
              size="small">
              {{ scope.row.status === 'online' ? '在线' : (scope.row.status === 'offline' ? '离线' : '未知') }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="application" label="绑定应用/工作流" min-width="180"></el-table-column>
        <el-table-column prop="createdAt" label="创建时间" width="160"></el-table-column>
        <el-table-column prop="lastActive" label="最后在线时间" width="160"></el-table-column>
        <el-table-column label="操作" width="260">
          <template slot-scope="scope">
            <div class="action-buttons">
              <el-button size="mini" type="primary" icon="el-icon-edit" circle @click="editClient(scope.row)"
                title="编辑"></el-button>
              <el-button size="mini" type="success" icon="el-icon-chat-line-round" circle
                @click="viewConversations(scope.row)" title="会话"></el-button>
              <el-button size="mini" type="warning" icon="el-icon-setting" circle @click="viewConfig(scope.row)"
                title="配置"></el-button>
              <el-button size="mini" type="danger" icon="el-icon-delete" circle @click="removeClient(scope.row)"
                title="删除"></el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>

      <div class="pagination">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage"
          :page-sizes="[10, 20, 50, 100]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper"
          :total="totalClients">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ClientManage',
  data () {
    return {
      searchText: '',
      currentPage: 1,
      pageSize: 10,
      totalClients: 0,
      clients: [
        {
          id: 'wxh-12345',
          name: '产品部客服',
          type: 'wechat',
          status: 'online',
          application: '智能客服',
          createdAt: '2024-05-01 10:30:00',
          lastActive: '2024-05-15 09:45:32'
        },
        {
          id: 'wxw-45678',
          name: '市场部助手',
          type: 'workwechat',
          status: 'online',
          application: '文档问答助手',
          createdAt: '2024-04-15 14:20:00',
          lastActive: '2024-05-15 10:12:18'
        },
        {
          id: 'ding-78901',
          name: '技术支持',
          type: 'dingtalk',
          status: 'offline',
          application: '技术支持工作流',
          createdAt: '2024-04-10 09:15:00',
          lastActive: '2024-05-14 18:30:45'
        },
        {
          id: 'web-23456',
          name: '官网客服',
          type: 'webpage',
          status: 'online',
          application: '客户咨询',
          createdAt: '2024-03-25 11:30:00',
          lastActive: '2024-05-15 11:05:27'
        },
        {
          id: 'api-34567',
          name: 'APP内置助手',
          type: 'api',
          status: 'online',
          application: '用户服务工作流',
          createdAt: '2024-03-20 10:00:00',
          lastActive: '2024-05-15 10:55:12'
        }
      ]
    };
  },
  computed: {
    filteredClients () {
      if (!this.searchText) {
        return this.clients;
      }
      const searchLower = this.searchText.toLowerCase();
      return this.clients.filter(client =>
        client.name.toLowerCase().includes(searchLower) ||
        client.id.toLowerCase().includes(searchLower) ||
        client.application.toLowerCase().includes(searchLower)
      );
    }
  },
  filters: {
    typeClass (type) {
      const classes = {
        wechat: 'wechat-icon',
        workwechat: 'workwechat-icon',
        dingtalk: 'dingtalk-icon',
        webpage: 'webpage-icon',
        api: 'api-icon'
      };
      return classes[type] || '';
    },
    typeIcon (type) {
      const icons = {
        wechat: 'el-icon-chat-dot-round',
        workwechat: 'el-icon-office-building',
        dingtalk: 'el-icon-bell',
        webpage: 'el-icon-monitor',
        api: 'el-icon-connection'
      };
      return icons[type] || 'el-icon-question';
    }
  },
  mounted () {
    this.totalClients = this.clients.length;
  },
  methods: {
    handleSizeChange (val) {
      this.pageSize = val;
      // 在实际应用中，这里应该请求API重新获取数据
    },
    handleCurrentChange (val) {
      this.currentPage = val;
      // 在实际应用中，这里应该请求API重新获取数据
    },
    editClient (client) {
      this.$message.info(`编辑客户端 ${client.name}`);
    },
    viewConversations (client) {
      this.$message.info(`查看 ${client.name} 的会话`);
    },
    viewConfig (client) {
      this.$message.info(`查看 ${client.name} 的配置`);
    },
    removeClient (client) {
      this.$confirm(`确认删除客户端 ${client.name}?`, '警告', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.clients = this.clients.filter(c => c.id !== client.id);
        this.totalClients = this.clients.length;
        this.$message.success('删除成功');
      }).catch(() => {
        this.$message.info('已取消删除');
      });
    }
  }
};
</script>

<style scoped>
.client-manage {
  padding-bottom: 50px;
}

.breadcrumb {
  margin-bottom: 20px;
}

.page-header {
  background-color: #fff;
  padding: 20px;
  border-radius: 4px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.05);
  margin-bottom: 20px;
  position: relative;
}

.client-title {
  font-size: 18px;
  font-weight: 600;
  color: #303133;
  margin-bottom: 15px;
}

.client-desc {
  font-size: 14px;
  color: #606266;
  line-height: 1.8;
  max-width: 80%;
}

.upgrade-btn {
  position: absolute;
  top: 20px;
  right: 20px;
}

.feature-section {
  margin-bottom: 30px;
}

.feature-card {
  background-color: #fff;
  padding: 20px;
  border-radius: 4px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.05);
  height: 100%;
  display: flex;
}

.feature-icon {
  width: 60px;
  height: 60px;
  border-radius: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
  margin-right: 15px;
  flex-shrink: 0;
}

.conversation-icon {
  background-color: #ecf5ff;
  color: #409EFF;
}

.monitor-icon {
  background-color: #f0f9eb;
  color: #67C23A;
}

.web-icon {
  background-color: #f5f7fa;
  color: #909399;
}

.feature-content {
  flex: 1;
}

.feature-title {
  font-size: 16px;
  font-weight: 600;
  color: #303133;
  margin-bottom: 10px;
  display: flex;
  align-items: center;
}

.feature-title i {
  margin-left: 5px;
  color: #909399;
}

.feature-desc {
  font-size: 13px;
  color: #606266;
  line-height: 1.6;
  margin-bottom: 15px;
}

.feature-tags {
  margin-top: auto;
}

.client-list {
  background-color: #fff;
  padding: 20px;
  border-radius: 4px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.05);
}

.list-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.list-title {
  font-size: 16px;
  font-weight: 600;
  color: #303133;
}

.client-info {
  display: flex;
  align-items: center;
}

.client-icon {
  width: 40px;
  height: 40px;
  border-radius: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  color: #fff;
  margin-right: 10px;
}

.wechat-icon {
  background-color: #07C160;
}

.workwechat-icon {
  background-color: #2A80FF;
}

.dingtalk-icon {
  background-color: #2BADFF;
}

.webpage-icon {
  background-color: #909399;
}

.api-icon {
  background-color: #409EFF;
}

.client-name {
  font-weight: 600;
  color: #303133;
}

.client-id {
  font-size: 12px;
  color: #909399;
}

.pagination {
  margin-top: 20px;
  text-align: right;
}

.action-buttons {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;
}

.action-buttons .el-button {
  margin: 0;
  transition: all 0.3s;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.action-buttons .el-button:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
}
</style>